import { collections } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

export default function CollectionsSection() {
  return (
    <section
      id="collections"
      className="scroll-mt-24 border-y border-background-200 bg-background-100/60 py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeading
            index="06"
            eyebrow="Collections"
            title="本周专题合集"
            desc="按题材把同类传闻打包，一次看完一个方向的流传与澄清，比零散刷到更省心。"
          />
          <span className="flex items-center gap-2 whitespace-nowrap font-label text-xs text-foreground-500">
            <i className="ri-stack-line text-sm text-primary-600" />
            共 89 篇归档内容
          </span>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {collections.map((item, index) => (
            <article
              key={item.title}
              data-reveal
              style={{ transitionDelay: `${index * 70}ms` }}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-200 hover:border-primary-300"
            >
              <div className="relative h-[180px] w-full overflow-hidden md:h-[190px]">
                <img
                  src={item.image}
                  alt={`${item.title}相关配图`}
                  title={`黑料学生 ${item.title}`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 font-label text-[11px] font-medium text-foreground-800 backdrop-blur-sm">
                  {item.count}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-[15px] font-semibold leading-snug text-foreground-950 transition-colors duration-200 group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2.5 flex-1 text-[13px] leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-label text-xs text-primary-700">
                  进入专题
                  <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-0.5" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}